import React from 'react';
import {
  Icon,
  SvgIcon,
} from '@material-ui/core';

export default [
  {
    name: 'Forms',
    description: 'Build & distribute forms so your workflows can be created with the right information.',
    icon: <Icon>create_new_folder</Icon>,
    features: [{
      name: 'Form Builder',
      description: 'Design your form so the proper information is provided and fields collected when users submit worklows.',
      icon: <Icon>list_alt</Icon>,
    }, {
      name: 'Publicly Available',
      description: 'Allow anyone anywhere to submit a workflow, not just individuals in your organization.',
      icon: <Icon>public</Icon>,
    }, {
      name: 'Embedded & Hosted Forms',
      description: 'Embed forms on your own website, or distribute a link to the publicly available Pingum hosted form.',
      icon: <Icon>web</Icon>,
    }, {
      name: 'Email Confirmations & Responses',
      description: 'Send custom email responses to those who submit a workflow including received receipt, status changes, and completions.',
      icon: <Icon>send</Icon>,
    }],
  },
  {
    name: 'Manage Workflows',
    description: 'Collaborate & interact with your team so workflows can be completed.',
    icon: <Icon>account_tree</Icon>,
    features: [{
      name: 'Worklows Dashboards',
      description: 'Visualize and track your workflows through custom dashboards and views including kanban, list, and grids.',
      icon: <Icon>dashboard</Icon>,
    }, {
      name: 'Custom Fields',
      description: 'Define the data fields you want to track and collect information on, in a variety of data formats including text, emails, addresses and more.',
      icon: <Icon>storage</Icon>,
    }, {
      name: 'Assignments & Dispatching',
      description: 'Assign or Dispatch workflows to team members so your team knows what they need to work on.',
      icon: <Icon>assignment_ind</Icon>,
    }, {
      name: 'Change Statuses',
      description: 'Move each workflow through different statuses as information changes and tasks are completed',
      icon: <Icon>sync</Icon>,
    }, {
      name: 'Comments',
      description: 'Communicate and track critical information about each workflow and with your team.',
      icon: <Icon>comment</Icon>,
    }, {
      name: 'Due Dates',
      description: 'Setup due dates so workflows can be completed in a timely matter.',
      icon: <Icon>event</Icon>,
    }, {
      name: 'File Attachments',
      description: 'Upload documents and images to any workflow for additional documentation.',
      icon: <Icon>attach_file</Icon>,
    }, {
      name: 'Tagging',
      description: 'Use tags to better group workflows into distinct or like categories.',
      icon: <Icon>local_offer</Icon>,
    }],
  },
  {
    name: 'Notifications',
    description: 'Get notified anytime and anywhere of your critical workflows.',
    icon: <Icon>notifications</Icon>,
    features: [{
      name: 'Subscriptions',
      description: 'Subscribe to workflows you care about, don&apos;t get flooded with unwanted notifications.',
      icon: <Icon>subscriptions</Icon>,
    }, {
      name: 'Email',
      description: 'Feed your email inbox with Pingum workflow notifications.',
      icon: <Icon>email</Icon>,
    }, {
      name: 'Mobile',
      description: 'Receive push notifiation on your phone.',
      icon: <Icon>sms</Icon>,
    }, {
      name: 'In App Alerts',
      description: 'Get notified from within the Pingum application.',
      icon: <Icon>notifications_active</Icon>,
    }, {
      name: 'Slack',
      description: 'Does your team use Slack? Route notifications to your channel.',
      icon: <SvgIcon><path d="M6,15A2,2 0 0,1 4,17A2,2 0 0,1 2,15A2,2 0 0,1 4,13H6V15M7,15A2,2 0 0,1 9,13A2,2 0 0,1 11,15V20A2,2 0 0,1 9,22A2,2 0 0,1 7,20V15M9,7A2,2 0 0,1 7,5A2,2 0 0,1 9,3A2,2 0 0,1 11,5V7H9M9,8A2,2 0 0,1 11,10A2,2 0 0,1 9,12H4A2,2 0 0,1 2,10A2,2 0 0,1 4,8H9M17,10A2,2 0 0,1 19,8A2,2 0 0,1 21,10A2,2 0 0,1 19,12H17V10M16,10A2,2 0 0,1 14,12A2,2 0 0,1 12,10V5A2,2 0 0,1 14,3A2,2 0 0,1 16,5V10M14,18A2,2 0 0,1 16,20A2,2 0 0,1 14,22A2,2 0 0,1 12,20V18H14M14,17A2,2 0 0,1 12,15A2,2 0 0,1 14,13H19A2,2 0 0,1 21,15A2,2 0 0,1 19,17H14Z" /></SvgIcon>,
    }],
  },
  {
    name: 'Using Pingum',
    description: 'Access Pingum & manager your workflows from the office, while on the go, or from your own systems.',
    icon: <Icon>devices</Icon>,
    features: [{
      name: 'Web Application',
      description: 'Login from any web browser.',
      icon: <Icon>computer</Icon>,
    }, {
      name: 'iPhone & iPad',
      description: 'Get Pingum from the Apple App Store,',
      icon: <SvgIcon><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" /></SvgIcon>,
    }, {
      name: 'Android Devices',
      description: 'Get Pingum from the Android Play Store.',
      icon: <Icon>android</Icon>,
    }, {
      name: 'Developer APIs',
      description: 'Use the Pingum 3rd Party APIs for a seamless integration.',
      icon: <Icon>code</Icon>,
    }],
  },
];
